// src/stage2/sceneExterior/TreelineRoad.jsx
import React, { useEffect } from 'react';
import { useTexture } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

export function TreelineRoad({
  x = 0,
  y = 1.99,
  z = -16.22,
  width = 8,
  height = 3.75,
  rotationY = 0,
  textureUrl = '/stageAssets/stage2/scene/treelineRoad.png',
  renderOrder = 30, // front-most of the three
}) {
  const texture = useTexture(textureUrl);
  const { gl } = useThree();

  useEffect(() => {
    if (!texture) return;
    const maxAniso = gl.capabilities.getMaxAnisotropy();

    texture.anisotropy = maxAniso;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
  }, [texture, gl]);

  return (
    <mesh position={[x, y, z]} rotation={[0, rotationY, 0]} renderOrder={renderOrder}>
      <planeGeometry args={[width, height]} />
      <meshBasicMaterial
        map={texture}
        alphaTest={0.15}     // adjust 0.05–0.25 if needed
        transparent={false}  // IMPORTANT: do NOT blend
        depthTest={true}
        depthWrite={true}
        toneMapped={false}
      />
    </mesh>
  );
}
